module.exports = __webpack_public_path__ + "assets/parents-selected.24f8f5ccaded58f1a3af12d4e85f0a4e.svg";